{
    "home.title": "My Stores",
    "home.store.openTasks": "Open Tasks",
    "home.stores.title": "Home",
    "home.noMobileAccess.title": "This account does not have access to the Badger Mobile app.",
    "home.noMobileAccess.body": "Contact your manager to request access.",
    "home.noHomeStore.message": "You do not have a home store set. Please contact your manager.",
    "home.myStores.title": "My Stores",
    "home.myStores.link": "Stores",
    "home.label.edit": "My Stores",

    "tasks.label": "Tasks",
    "tasks.store.allTasks": "All Tasks",
    "tasks.filters.allTaskTypes": "All Task Types",
    "tasks.filters.allResolutionTypes": "All Resolution Types",
    "tasks.store.idLabel": "Store ID",
    "tasks.store.outOfStock": "Out-of-Stock",
    "tasks.store.wrong": "Wrong",
    "tasks.store.price": "Price",
    "tasks.store.salePrice": "Sale Price",
    "tasks.store.taskMap": "Task Map",
    "tasks.allAisles": "All Aisles",
    "tasks.supress.message": "This task will be snoozed for 7 days.",
    "tasks.list.completeTask": "Complete Task",
    "tasks.list.flagTask": "Flag Task",
    "tasks.store": "Store",
    "tasks.aisles": "Aisles",
    "tasks.complete.message": "Task completed successfully.",
    "tasks.error.message": "Something went wrong while completing the task.",
    "tasks.general.message": "Unable to complete the task. Please try again later.",

    "locator.products": "Products",
    "locator.locations": "Locations",
    "locator.search.label": "Search by name, gtin, sku, etc...",
    "locator.items.count": "{count, plural, one {1 item} other {# items}}",
    "locator.locations.count": "{count, plural, one {1 location} other {# locations}}",
    "locator.noresults.message": "We couldn't find any products matching your search.",
    "locator.hint.message": "Start typing a product Name, SKU, or GTIN to locate any detected products in your store.",
    "profile.title": "Profile",
    "profile.name.label": "Name",
    "profile.email.label": "Email",
    "profile.organization.label": "Organization",
    "profile.homeStore.label": "Home Store",
    "profile.role.label": "Role",
    "profile.roles.label": "Roles",

    "general.label.today": "Today",
    "general.label.search": "Search",
    "general.label.comment": "Comment",
    "general.label.comments": "Comments",
    "general.label.resolved": "Resolved",
    "general.label.new": "New",
    "general.label.edit": "Edit",
    "general.label.signOut": "Sign Out",
    "general.label.actionable": "Actionable",
    "general.action.save": "Save",
    "general.action.cancel": "Cancel",
    "general.action.close": "Close",
    "general.action.snooze": "Snooze",
    "general.action.create": "Create",
    "general.home.title": "Home",
    "general.tasks.title": "Tasks",
    "general.users.title": "Profile",
    "general.rfid.title": "RFID",
    "general.topstock.title": "Top Stock",
    "general.locator.title": "Product Locator",
    "general.label.products": "Products",
    "general.action.prev": "Prev",
    "general.action.next": "Next",
    "general.restricted": "Restricted",
    "general.restricted.info": "Your organization is restricted from accessing this app. Contact your representative.",
    "general.label.gtin": "GTIN",
    "general.label.sku": "SKU",
    "general.label.all": "All",
    "general.label.aisle": "Aisle",
    "general.nodata.message": "No Data Available",
    "general.noresults.message": "No Results Found",

    "sort.label.taskCount": "Task Count",
    "sort.label.aisleName": "Aisle Name",
    "sort.label.aisleLocation": "Aisle Location",
    "sort.label.shelfLocation": "Shelf Location",
    "sort.label.taskType": "Task Type",
    "sort.label.productName": "Product Name",
    "sort.label.sku": "SKU",
    "sort.label.recurrenceCount": "Recurrence Count",
    "sort.label.tagCount": "Tag Count",

    "task.type.price": "Price",
    "task.type.salePrice": "Sale Price",
    "task.type.outOfStock": "Out-of-Stock",
    "task.type.wrong": "Wrong Item",

    "task.resolution.autoResolved": "Auto Resolved",
    "task.resolution.completed": "Completed",
    "task.resolution.flagged": "Flagged",
    "task.resolution.not a problem": "No issues found",
    "task.resolution.no stock found": "No stock available to fill",

    "task.status.active": "Active",
    "task.status.completed": "Resolved",
    "task.status.suppressed": "Snoozed",
    "task.status.expired": "Expired",

    "tasks.paths.label": "Aisles",

    "validation.error.required": "This field is required",
    "validation.error.minLength": "Minimum length is {{length}} characters",

    "user.label.email": "Email",
    "user.label.email.placeholder": "Email",
    "user.label.email.error": "Email Required",
    "user.label.email.invalid": "Invalid Email Format",
    "user.label.firstName": "First Name",
    "user.label.firstName.placeholder": "First Name",
    "user.label.firstName.error": "First Name Required",
    "user.label.lastName": "Last Name",
    "user.label.lastName.placeholder": "Last Name",
    "user.label.lastName.error": "Last Name Required",
    "user.label.organization": "Organization",
    "user.label.homeStore": "Home Store",
    "user.label.homeStore.placeholder": "Search home stores",
    "user.label.homeStore.noFound": "No home stores found",
    "user.label.allowedStores": "Allowed Stores",
    "user.select.store.placeholder": "Search stores",
    "user.select.store.noFound": "No stores found",
    "user.label.roles": "Roles",

    "rfid.label.tag": "RFID Tag",
    "rfid.label.allZones": "All Zones",
    "rfid.label.serial": "Serial",
    "rfid.label.epc": "Epc",
    "rfid.label.zone": "Zone",
    "rfid.label.date": "Date",
    "rfid.label.nonLocalized": "Nonlocalized",

    "signOut.success": "Your session has ended. Please sign in to access your account.",
    "signOut.error": "An error occurred while signing out. Please try again."
}
